import Joi from 'joi'
import errorsResolver from '../../../../validation/schemeUtils'
import {nonCashValidate} from "../../../../validation/scheme/nonCash";

const warningCheckingForInvalidCharacters = `Поле ввода содержит некорректные символы`
const incorrectInsertionValue = `Вставка содержит некорректные символы`

export const puritiesSchemaFunc = (configure) => {

    const NAME_FIELD_LENGTH = configure ? 20 : 60
    const COMMENT_FIELD_LENGTH = configure ? 14 : 90
    const ADD_INFO_FIELD_LENGTH = configure ? 20 : 90
    const IS_PART_NAME_LENGTH = configure ? 21 : 60;

    return Joi.object({
        positions: Joi.array().items(
            Joi.object({
                comment: Joi.string()
                    .max(COMMENT_FIELD_LENGTH)
                    .allow('')
                    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,!{}#()$%^&*~_/,№:?”";`\\- ]*$'))
                    .error(errorsResolver({
                        max: `Вставка должна быть до ${COMMENT_FIELD_LENGTH} символов`,
                        pattern: incorrectInsertionValue
                    })),
                grossWeight: Joi.number()
                    .min(0.01)
                    .error(errorsResolver({
                        numberMin: 'Общий вес должен быть больше нуля',
                        number: 'Общий вес обязательно поле или должен быть числом',
                    })),
                names: Joi.when('isPart', {
                    is: true,
                    then: Joi.object({
                        label: Joi.string()
                            .max(IS_PART_NAME_LENGTH)
                            .required()
                            .error(errorsResolver({
                                max: `Наименование должно быть до ${IS_PART_NAME_LENGTH} символов`,
                                required: `Наименование обязательное поле`,
                            })),
                        part: Joi.any(),
                        value: Joi.number()
                            .error(errorsResolver({
                                required: `Наименование обязательное поле`,
                                number: `Должно быть число`
                            }))
                    }),
                    otherwise: Joi.object({
                        label: Joi.string()
                            .max(NAME_FIELD_LENGTH)
                            .required()
                            .error(errorsResolver({
                                max: `Наименование должно быть до ${NAME_FIELD_LENGTH} символов`,
                                required: `Наименование обязательное поле`,
                            })),
                        part: Joi.any(),
                        value: Joi.number()
                            .error(errorsResolver({
                                required: `Наименование обязательное поле`,
                                number: `Должно быть число`
                            }))
                    })
                })
                    .required()
                    .error(errorsResolver({
                        invalid: `Наименование обязательное поле`,
                        required: `Наименование обязательное поле`,
                    }))
                    .invalid(null)
                    .error(errorsResolver({
                        includesRequiredUnknowns: `Наименование обязательное поле`
                    })),
                positionId: Joi.number()
                    .error(errorsResolver({
                        number: `Должно быть число`
                    })),
                purityPrice: Joi.number()
                    .error(errorsResolver({
                        number: `Должно быть число`
                    })),
                pureWeight: Joi.number()
                    .required()
                    .invalid(-0, 0, "-")
                    .max(Joi.ref('grossWeight'))
                    .precision(2)
                    .error(errorsResolver({
                        number: 'Лигатурный вес обязательно поле или должен быть числом',
                        max: 'Лигатурный вес должен быть не больше общего веса',
                        invalid: 'Лигатурный вес не может быть равен 0 или -',
                        required: 'Лигатурный вес обязательное поле',
                    })),
                quantity: Joi.number()
                    .error(errorsResolver({
                        number: `Количество обязательно поле или должно быть числом`
                    })),
                isPart: Joi.bool(),
                showComment: Joi.bool(),
                additionalInfo: Joi.string()
                    .allow('')
                    .max(ADD_INFO_FIELD_LENGTH)
                    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.+-,-!()_/,№:?”;" ]*$'))
                    .error(errorsResolver({
                        max: `Длина доп. описания должна быть меньше или равна ${ADD_INFO_FIELD_LENGTH} символам`,
                        pattern: warningCheckingForInvalidCharacters
                    })),
                purityIdNamePrice: Joi.object({
                    label: Joi.string()
                        .min(1)
                        .required()
                        .error(errorsResolver({
                            required: `Наименование обязательное поле`,
                            min: `Проба обязательное поле`
                        })),
                    price: Joi.number()
                        .error(errorsResolver({
                            number: `Проба обязательное поле`
                        })),
                    value: Joi.number()
                        .error(errorsResolver({
                            number: `Проба обязательное поле`
                        }))
                })
                    .invalid(null)
                    .error(errorsResolver({
                        invalid: `Проба обязательное поле`
                    })),
            })
        ),
        coupon: Joi.any(),
        calculation: {
            endDate: Joi.date()
                .iso()
                .error(errorsResolver({
                    dateFormat: `Некорректная дата`,
                })),
            ticketLost: Joi.bool(),
            deposit: nonCashValidate,
        }
    })

}
